import EmptyPage from "./EmptyPage";

export default EmptyPage;
